// extracted by mini-css-extract-plugin
export default {"ModalHeader":"ModalHeader_ModalHeader__cmSX8"};